import { useField, useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, Typography } from '@material-ui/core';
const StyledGrid = styled(Grid) `
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  .error-label {
    color: ${props => props.theme.palette.error.main};
  }
`;
export const InlineMultiSelect = props => {
    let { label, name, error, disabled, options, grid, children } = props;
    const formik = useFormikContext();
    const [field, meta, { setValue, setTouched }] = useField(props);
    if (!grid) {
        // default field to expand entire width of form
        grid = { xs: 12 };
    }
    const handleChange = (event, value) => {
        // field.onChange(event);
        let values = [...field.value];
        if (values.includes(value)) {
            values = values.filter(item => item !== value);
            setValue(values);
        }
        else {
            values.push(value);
            setValue(values);
        }
        // setTouched(true);
        formik.submitForm();
    };
    return useMemo(() => (React.createElement(StyledGrid, Object.assign({ item: true, className: 'inline-multi-select' }, grid),
        React.createElement(Typography, { variant: 'h5', gutterBottom: true, className: error || meta.error ? 'error-label' : '' }, label),
        React.createElement(FormControl, Object.assign({ error: meta.touched && Boolean(meta.error), component: 'fieldset' }, field, { name: name }),
            React.createElement(FormGroup, null,
                options &&
                    options.map(option => {
                        var _a, _b;
                        return typeof option === 'string' ? (React.createElement(FormControlLabel, { key: option, control: React.createElement(Checkbox, { value: option, color: 'primary', disabled: disabled, checked: (_a = field.value) === null || _a === void 0 ? void 0 : _a.includes(option), onChange: event => handleChange(event, option) }), label: option })) : (React.createElement(FormControlLabel, { key: option.value, control: React.createElement(Checkbox, { value: option.value, color: 'primary', disabled: disabled, checked: (_b = field.value) === null || _b === void 0 ? void 0 : _b.includes(option.value), onChange: event => handleChange(event, option.value) }), label: option.label }));
                    }),
                children),
            (error || meta.error) && (React.createElement(FormHelperText, { error: true }, error || meta.error))))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [field.value, meta.error, label, options]);
};
export default InlineMultiSelect;
//# sourceMappingURL=InlineMultiSelect.js.map